module.exports = __webpack_public_path__ + "static/media/pixie-wings.67199cdc.gif";